import Vue from 'vue';
import { fetchOrders, sendOrderData } from '../../api';

const state = {
  isLoading: false,
  list: [],
  pagination: {
    rowsPerPage: -1,
    page: 1,
    totalItems: 0,
  },
};

const getters = {
  list: ({ list }) => list,
  isLoading: ({ isLoading }) => isLoading,
  pagination: ({ pagination }) => pagination,
};

const actions = {
  loadOrders({ commit }, { page = 1, filters = {} }) {
    commit('setLoading', true);
    fetchOrders({ page, ...filters })
      .then(({
        orders,
        count,
        page: pageRes,
      }) => {
        commit('setOrders', orders);
        commit('setPagination', {
          page: pageRes,
          totalItems: count,
        });
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  updateOrder({ commit }, { id, ...rest }) {
    commit('setLoading', true);
    sendOrderData({ id, payload: { ...rest } })
      .then((order) => {
        commit('setOrderData', order);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};

const mutations = {
  // eslint-disable-next-line
  setLoading(state, payload) {
    // eslint-disable-next-line
    state.isLoading = !!payload;
  },
  // eslint-disable-next-line
  setOrders(state, payload) {
    // eslint-disable-next-line
    state.list = payload;
  },
  // eslint-disable-next-line
  setPagination(state, payload) {
    // eslint-disable-next-line
    state.pagination = {
      ...state.pagination,
      ...payload,
    };
  },
  // eslint-disable-next-line
  setOrderData(state, payload) {
    // eslint-disable-next-line
    const findInd = state.list.findIndex(el => el.id === payload.id);
    if (findInd > -1) {
      Vue.set(state.list, findInd, payload);
    } else {
      Vue.set(state.list, state.list.length, payload);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
